function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2832 16H18.2177L16.5315 6.31399C16.1981 4.39834 14.5353 3 12.5908 3H2C0.89543 3 0 3.89543 0 5C0 6.10457 0.89543 7 2 7H12.5908L20.1957 50.686C20.5292 52.6017 22.192 54 24.1365 54H62C63.1046 54 64 53.1046 64 52C64 50.8954 63.1046 50 62 50H24.1365L22.7392 41.9734L62.1263 38.0347C62.9661 37.9508 63.6629 37.3486 63.8676 36.5297L66 28H51.1556C44.3072 28 38.5947 22.8467 37.2832 16Z",
  fill: "#FF2F3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M61 60.5C61 62.9853 58.9853 65 56.5 65C54.0147 65 52 62.9853 52 60.5C52 58.0147 54.0147 56 56.5 56C58.9853 56 61 58.0147 61 60.5Z",
  fill: "#FF2F3A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31 60.5C31 62.9853 28.9853 65 26.5 65C24.0147 65 22 62.9853 22 60.5C22 58.0147 24.0147 56 26.5 56C28.9853 56 31 58.0147 31 60.5Z",
  fill: "#FF2F3A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.1555 19.17H59.8725C60.7395 18.099 61.9635 16.586 62.5075 15.872C64.3265 13.441 64.9045 12.149 64.9045 10.228C64.9045 7.93302 63.2555 6.04602 60.3825 6.04602C57.5775 6.04602 55.8775 7.93302 55.8775 10.245C55.8775 12.591 57.4585 14.359 60.2635 14.393C60.6035 14.393 60.9435 14.325 61.2155 14.206C60.9824 14.5214 60.7051 14.8699 60.4014 15.2516C60.3285 15.3431 60.2541 15.4366 60.1785 15.532C59.9408 15.8331 59.6219 16.219 59.2855 16.6262C58.9 17.0927 58.4913 17.5874 58.1555 18.014V19.17ZM60.3825 12.557C58.8865 12.557 58.1045 11.537 58.1045 10.245C58.1045 8.97002 58.9205 7.93302 60.3825 7.93302C61.8955 7.93302 62.6605 8.97002 62.6605 10.262C62.6605 11.537 61.8615 12.557 60.3825 12.557Z",
  fill: "#FFB800"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.769 14.138V12.421H51.794V9.41202H49.958V12.421H47V14.138H49.958V17.164H51.794V14.138H54.769Z",
  fill: "#FFB800"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.0824 19.17H68.3654V18.014C68.7012 17.5875 69.1097 17.0931 69.4952 16.6265C69.8317 16.2193 70.1507 15.8331 70.3884 15.532C70.4638 15.437 70.5379 15.3439 70.6104 15.2527L70.6113 15.2516C70.915 14.8699 71.1923 14.5214 71.4254 14.206C71.1534 14.325 70.8134 14.393 70.4734 14.393C67.6684 14.359 66.0874 12.591 66.0874 10.245C66.0874 7.93302 67.7874 6.04602 70.5924 6.04602C73.4654 6.04602 75.1144 7.93302 75.1144 10.228C75.1144 12.149 74.5364 13.441 72.7174 15.872C72.1734 16.586 70.9494 18.099 70.0824 19.17ZM68.3144 10.245C68.3144 11.537 69.0964 12.557 70.5924 12.557C72.0714 12.557 72.8704 11.537 72.8704 10.262C72.8704 8.97002 72.1054 7.93302 70.5924 7.93302C69.1304 7.93302 68.3144 8.97002 68.3144 10.245Z",
  fill: "#FFB800"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39 13C39 5.8203 44.8203 0 52 0H71C78.1797 0 84 5.8203 84 13C84 20.1797 78.1797 26 71 26H52C44.8203 26 39 20.1797 39 13ZM52 2H71C77.0751 2 82 6.92487 82 13C82 19.0751 77.0751 24 71 24H52C45.9249 24 41 19.0751 41 13C41 6.92487 45.9249 2 52 2Z",
  fill: "#FFB800"
});

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 65,
    viewBox: "0 0 84 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.1c1d85b2.svg";
export { ForwardRef as ReactComponent };